const images = {};

const requireContext = require.context('.', false, /\.(png|jpe?g|svg)$/);

requireContext.keys().forEach((filename) => {
    const key = filename.replace('./', '').replace(/\.(png|jpe?g|svg)$/, '');
    images[key] = requireContext(filename);
});

export default images;